import { dataGridPremiumColumns } from '../../utils/helper';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useFormikContext } from 'formik';

const GroupsDataGrid = ({ formPropertyGroup, disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const selectedRows = values.formPropertyGroup?.map((row) => row.groupId) ?? [];

  const handleRowSelectionModelChange = (newRowSelectionModel) => {
    const updatedFormPropertyGroup = newRowSelectionModel.map((groupId) => {
      const group = formPropertyGroup.find((row) => row.id === groupId);

      return {
        formId: group.formId,
        groupId: group.id,
      };
    });

    setFieldValue('formPropertyGroup', updatedFormPropertyGroup);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      type: 'string',
      headerName: 'Csoportok',
    },
  ]);

  return (
    <DatagridPremiumUi
      sx={{
        '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
          display: 'none',
        },
      }}
      datagridIdentifier={DataGridIdentifiers.groupsDataGrid}
      datagridInitialState={{ density: 'compact' }}
      slots={{
        toolbar: null,
      }}
      height={300}
      columns={columns}
      rows={formPropertyGroup}
      paginationAndfilterMode="client"
      checkboxSelection
      disableRowSelectionOnClick={true}
      rowSelectionModel={selectedRows}
      isRowSelectable={() => !disabled}
      onRowSelectionModelChange={handleRowSelectionModelChange}
      hideFooter
    />
  );
};

export default GroupsDataGrid;
